import { render, staticRenderFns } from "./display.vue?vue&type=template&id=28e1d8aa"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports